<template>
    <div class="service-content-box mt-spc17 flex items-start xl:justify-between lg:justify-between justify-between md:justify-normal flex-wrap">
        <ServiceOneItems :service="service" v-for="(service, i) in serviceDatas.serviceLists" :key="i" />
    </div>
</template>

<script>
    import ServiceOneItems from "./ServiceOneItems";

    let serviceDatas = {
        serviceLists: [
            {
                icon: require("@/assets/images/service-1.png"),
                title: "Training doesn’t stick",
                content: "87% of training content is \nforgotten within 30 days"
            },
            {
                icon: require("@/assets/images/service-2.png"),
                title: "Hide and seek assets",
                content: "65% of sales reps say they \ncan’t find content to share with \nprospects"
            },
            {
                icon: require("@/assets/images/service-3.png"),
                title: "Too many manual tasks",
                content: "37% of a sales rep’s time is \nspent actually selling"
            },
            {
                icon: require("@/assets/images/service-4.png"),
                title: "Mediocre performance",
                content: "42% of sales reps fail to \nachieve quota"
            },
            {
                icon: require("@/assets/images/service-5.png"),
                title: "Missed opportunities",
                content: "65% of content is unused \nby sales"
            },
        ]
    }

    export default {
        name: "ServiceOne",
        components: {
            ServiceOneItems
        },
        data() {
            return {
                serviceDatas
            }
        }
    }
</script>

<style scoped>

</style>